import { AccountSchoolOutlineIcon } from './AccountSchoolOutlineIcon';

/**
 * author: Contributors
 * id DB767D52-F1C9-4986-B785-98314B70B2FF
 * name account-school-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-school-outline.svg
 * tags
 * - Account / User 
 */
export const AccountStudentOutlineIcon = AccountSchoolOutlineIcon;
export default AccountStudentOutlineIcon